const translatedUserTags: Record<string, string> = {
  'FINANCE': 'administration.users.tag.finance',
  'INVOICE': 'administration.users.tag.invoice',
  'COMMERCIAL': 'administration.users.tag.commercial',
  'TECHNICAL': 'administration.users.tag.technical',
  'INVOICE_BCC': 'administration.users.tag.invoice.bcc',
  'REPORT': 'administration.users.tag.report',
};

export default translatedUserTags;